import { isPlatformNative } from '../../utilities'
import Logger from '../../services/logger.service'
import { Userpilot as userPilotNative } from '@userpilot/capacitor'
import { Userpilot as userPilotWeb } from 'userpilot'

const userpilotSettingsWeb = {
  token: `${process.env.REACT_APP_USER_PILOT_TOKEN}`,
  auto_capture: {
    enabled: false,
    excluded_elements: ['[data-private="true"]'],
    masked_elements: ['[data-private="true"]'],
    excluded_attributes: ['data-private', 'data-secret'],
  },
}

const userpilotSettingsMobile = {
  token: `${process.env.REACT_APP_USER_PILOT_TOKEN}`,
  config: { logging: process.env.REACT_APP_USER_PILOT_LOGGING === 'true' || false },
}

export const isUserpilotEnabled = () => {
  return process.env.REACT_APP_ENABLE_USER_PILOT === 'true'
}

export const initUserpilot = async () => {
  if (!isUserpilotEnabled()) {
    Logger.info('Userpilot is not enabled, skipping initUserpilot')
    return
  }
  try {
    if (isPlatformNative()) {
      userPilotNative.initialize(userpilotSettingsMobile)
      Logger.info('Userpilot native initialized')
    } else {
      userPilotWeb.initialize(`${process.env.REACT_APP_USER_PILOT_TOKEN}`, userpilotSettingsWeb)
      Logger.info('Userpilot web initialized')
    }
  } catch (err) {
    Logger.errorObj(`initUserpilot failed err: `, err)
  }
}
